import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives } from "vue";
import { reactive, ref } from "vue";
import apis from "@/api";
import { ElMessage } from "element-plus";
export default {
  __name: 'ReportDetailEdit',
  props: {
    title: {
      type: String,
      default: '人工复核修正',
      required: false
    },
    visible: {
      type: Boolean,
      default: false
    },
    detailReport: {
      type: Object
    },
    oldDetailReport: {
      type: Object
    }
  },
  emits: ['success', 'update:visible'],
  setup(__props, {
    emit: __emit
  }) {
    const emits = __emit;
    const props = __props;
    const openHandler = () => {
      data.form = JSON.parse(JSON.stringify(props.detailReport));
      data.oldForm = JSON.parse(JSON.stringify(props.oldDetailReport));
      hasHisCheckFlag.value = false;
      monitorPublicFitCheckFlag.value = false;
      timeFitCheckFlag.value = false;
      locationFitCheckFlag.value = false;
      disabledConfirm.value = false;
      if (data.form.action && data.form.action == "record") {
        disabled.value = false;
        if (data.form.hasHis !== data.oldForm.hasHis) {
          hasHisCheckFlag.value = true;
        }
        if (data.form.monitorPublicFit !== data.oldForm.monitorPublicFit) {
          monitorPublicFitCheckFlag.value = true;
        }
        if (data.form.timeFit !== data.oldForm.timeFit) {
          timeFitCheckFlag.value = true;
        }
        if (data.form.locationFit !== data.oldForm.locationFit) {
          locationFitCheckFlag.value = true;
        }
        if (data.form.auditState !== null) {
          data.auditState = data.form.auditState + "";
          disabledConfirm.value = true;
        } else {
          data.auditState = "1";
          disabledConfirm.value = false;
        }
      } else {
        disabled.value = true;
      }
    };
    const data = reactive({
      form: {},
      oldForm: {},
      suppliers: [],
      role: {},
      userList: [],
      userShow: false,
      checkUser: [],
      areaCode: "",
      auditState: "1",
      rules: {
        checkDesc: [{
          required: true,
          message: '请输入复核说明',
          trigger: 'blur'
        }]
      }
    });
    const addForm = ref(null);
    const elLoading = ref(false);
    const disabled = ref(false);
    const disabledConfirm = ref(false);
    const hasHisCheckFlag = ref(false);
    const monitorPublicFitCheckFlag = ref(false);
    const timeFitCheckFlag = ref(false);
    const locationFitCheckFlag = ref(false);
    const close = () => {
      data.form = {};
      emits('update:visible', false);
    };

    // const handleSaveReport = () => {
    //   if (data.form.hasHis === 0) {
    //     data.form.hisCount = 0
    //   }
    //   if (data.form.hasHis === 1) {
    //     if (data.form.hisCount == 0) {
    //       ElMessage.error("历史图片有相似时,图片数量应大于0,请重新提交！")
    //       return
    //     }
    //   }
    //   apis.handleReportEdit(data.form).then(res => {
    //     if (res.success) {
    //       ElMessage.success("复核成功!")
    //       emits("success")
    //     }
    //   }).catch(err => {
    //     ElMessage.error(err)
    //   }).finally(() => {
    //     close()
    //   })
    //
    // }

    const handleSaveReport = () => {
      addForm.value.validate(valid => {
        if (valid) {
          if (data.form.hasHis === 0) {
            if (data.form.hisCount > 0) {
              ElMessage.error("历史图片无相似时,图片数量应等于0,请重新提交！");
              return;
            }
          }
          if (data.form.hasHis === 1) {
            if (data.form.hisCount == 0) {
              ElMessage.error("历史图片有相似时,图片数量应大于0,请重新提交！");
              return;
            }
          }
          if (data.form.action && data.form.action == "check") {
            //未改变数据则不能提交复核
            if (data.form.hasHis === data.oldForm.hasHis && data.form.monitorPublicFit === data.oldForm.monitorPublicFit && data.form.timeFit === data.oldForm.timeFit && data.form.locationFit === data.oldForm.locationFit) {
              ElMessage.error("未修正任何数据，不能提交复核申请！");
              return;
            }
          }
          apis.handleCheckRecordAdd(data.form).then(res => {
            if (res.success) {
              ElMessage.success("添加复核记录成功!");
              emits("success");
            }
          }).catch(err => {
            ElMessage.error(err);
          }).finally(() => {
            close();
          });
        }
      });
    };
    const handleCheckRecordAudit = () => {
      data.form.auditStatus = parseInt(data.auditState);
      apis.handleCheckRecordAudit(data.form).then(res => {
        if (res.success) {
          ElMessage.success("审核成功!");
          emits("success");
        }
      }).catch(err => {
        ElMessage.error(err);
      }).finally(() => {
        close();
      });
    };
    return (_ctx, _cache) => {
      const _component_el_option = _resolveComponent("el-option");
      const _component_el_select = _resolveComponent("el-select");
      const _component_el_col = _resolveComponent("el-col");
      const _component_el_form_item = _resolveComponent("el-form-item");
      const _component_el_input = _resolveComponent("el-input");
      const _component_el_radio = _resolveComponent("el-radio");
      const _component_el_radio_group = _resolveComponent("el-radio-group");
      const _component_el_form = _resolveComponent("el-form");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_dialog = _resolveComponent("el-dialog");
      const _directive_loading = _resolveDirective("loading");
      return _openBlock(), _createBlock(_component_el_dialog, {
        title: __props.title,
        "model-value": __props.visible,
        onOpen: openHandler,
        onClose: close,
        "close-on-press-escape": false,
        "destroy-on-close": true,
        width: "30%"
      }, {
        footer: _withCtx(() => [_createVNode(_component_el_button, {
          onClick: close
        }, {
          default: _withCtx(() => [...(_cache[10] || (_cache[10] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), data.form.roleFlag != '1' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          type: "primary",
          onClick: handleSaveReport,
          disabled: !disabled.value
        }, {
          default: _withCtx(() => [...(_cache[11] || (_cache[11] = [_createTextVNode("确认", -1)]))]),
          _: 1
        }, 8, ["disabled"])) : _createCommentVNode("", true), data.form.roleFlag == '1' ? (_openBlock(), _createBlock(_component_el_button, {
          key: 1,
          type: "primary",
          onClick: handleCheckRecordAudit,
          disabled: disabledConfirm.value
        }, {
          default: _withCtx(() => [...(_cache[12] || (_cache[12] = [_createTextVNode("确认", -1)]))]),
          _: 1
        }, 8, ["disabled"])) : _createCommentVNode("", true)]),
        default: _withCtx(() => [_withDirectives((_openBlock(), _createBlock(_component_el_form, {
          model: data.form,
          "label-width": "110px",
          "label-position": "left",
          ref_key: "addForm",
          ref: addForm,
          rules: data.rules
        }, {
          default: _withCtx(() => [_createVNode(_component_el_form_item, {
            label: "历史图片",
            prop: "hasHis",
            class: _normalizeClass(hasHisCheckFlag.value ? 'check-flag' : '')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 16
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: data.form.hasHis,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => data.form.hasHis = $event),
                disabled: !disabled.value
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "无相似",
                  value: 0
                }), _createVNode(_component_el_option, {
                  label: "有相似",
                  value: 1
                })]),
                _: 1
              }, 8, ["modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["class"]), _createVNode(_component_el_form_item, {
            label: "历史图片数量",
            prop: "hisCount"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 16
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                type: "number",
                oninput: "if(value<0)value=0",
                modelValue: data.form.hisCount,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => data.form.hisCount = $event),
                disabled: !disabled.value
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          }), _createVNode(_component_el_form_item, {
            label: "监测与投放",
            prop: "monitorPublicFit",
            class: _normalizeClass(monitorPublicFitCheckFlag.value ? 'check-flag' : '')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 16
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: data.form.monitorPublicFit,
                "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => data.form.monitorPublicFit = $event),
                disabled: !disabled.value
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "不一致",
                  value: 0
                }), _createVNode(_component_el_option, {
                  label: "一致",
                  value: 1
                })]),
                _: 1
              }, 8, ["modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["class"]), _createVNode(_component_el_form_item, {
            label: "时间比对",
            prop: "timeFit",
            class: _normalizeClass(timeFitCheckFlag.value ? 'check-flag' : '')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 16
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: data.form.timeFit,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => data.form.timeFit = $event),
                disabled: !disabled.value
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "不符合",
                  value: 0
                }), _createVNode(_component_el_option, {
                  label: "符合",
                  value: 1
                })]),
                _: 1
              }, 8, ["modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["class"]), _createVNode(_component_el_form_item, {
            label: "位置比对",
            prop: "locationFit",
            class: _normalizeClass(locationFitCheckFlag.value ? 'check-flag' : '')
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 16
            }, {
              default: _withCtx(() => [_createVNode(_component_el_select, {
                modelValue: data.form.locationFit,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => data.form.locationFit = $event),
                disabled: !disabled.value
              }, {
                default: _withCtx(() => [_createVNode(_component_el_option, {
                  label: "不符合",
                  value: 0
                }), _createVNode(_component_el_option, {
                  label: "符合",
                  value: 1
                })]),
                _: 1
              }, 8, ["modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          }, 8, ["class"]), _createVNode(_component_el_form_item, {
            label: "复核说明",
            prop: "checkDesc"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 16
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: data.form.checkDesc,
                "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => data.form.checkDesc = $event),
                rows: 2,
                type: "textarea",
                placeholder: "请输入复核说明",
                disabled: !disabled.value
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          }), data.form.roleFlag == '1' || data.form.auditState != null ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 0,
            label: "是否同意修改",
            prop: "auditState"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 16
            }, {
              default: _withCtx(() => [_createVNode(_component_el_radio_group, {
                modelValue: data.auditState,
                "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => data.auditState = $event),
                class: "ml-4",
                disabled: disabledConfirm.value
              }, {
                default: _withCtx(() => [_createVNode(_component_el_radio, {
                  label: "1",
                  border: ""
                }, {
                  default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("同意", -1)]))]),
                  _: 1
                }), _createVNode(_component_el_radio, {
                  label: "0",
                  border: ""
                }, {
                  default: _withCtx(() => [...(_cache[9] || (_cache[9] = [_createTextVNode("不同意", -1)]))]),
                  _: 1
                })]),
                _: 1
              }, 8, ["modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true), data.form.roleFlag == '1' || data.form.auditState != null ? (_openBlock(), _createBlock(_component_el_form_item, {
            key: 1,
            label: "审核意见",
            prop: "auditDesc"
          }, {
            default: _withCtx(() => [_createVNode(_component_el_col, {
              span: 16
            }, {
              default: _withCtx(() => [_createVNode(_component_el_input, {
                modelValue: data.form.auditDesc,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => data.form.auditDesc = $event),
                rows: 2,
                type: "textarea",
                placeholder: "请输入审核意见",
                disabled: disabledConfirm.value
              }, null, 8, ["modelValue", "disabled"])]),
              _: 1
            })]),
            _: 1
          })) : _createCommentVNode("", true)]),
          _: 1
        }, 8, ["model", "rules"])), [[_directive_loading, elLoading.value]])]),
        _: 1
      }, 8, ["title", "model-value"]);
    };
  }
};